import React, { useRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonBase from "@mui/material/ButtonBase";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useHistory } from "react-router";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import MenuDialog from "~/components/Blocks/MenuDialog";
import TextField from "@mui/material/TextField";

import { MenuSet } from "~slices/Menu";

const MenuList = (props) => {
    const { menu_list = [], menu_group_id, app_button, select_button, onSelect, onReselect, onAdd, DelClick, party_date, check_menu_id } = props;

    const dispatch = useDispatch();
    const history = useHistory();

    const menu_state = useSelector((state) => state.Menu);

    // リストに存在する場合は選択対象から除外する。
    const select_menu_id_list = menu_state.select_menu_id_list;

    useEffect(() => {
        // dispatch(MenuSet(["select_menu_id_list", []]));

        if (props.select_menu) {
            const select_menu_list = menu_list.filter((value) => value.menu_id !== props.select_menu);
            const menu_id_list = select_menu_list.map((obj) => obj.menu_id);
            dispatch(MenuSet(["select_menu_id_list", menu_id_list]));
        } else {
            if(menu_list.length > 0)
            {
                const menu_id_list = menu_list.map((obj) => obj.menu_id);
                dispatch(MenuSet(["select_menu_id_list", menu_id_list]));
                if(props.SelectCheck && check_menu_id)
                {
                    //トップページで商品が選択されていた場合のチェック処理
                    let new_select_menu_id_list = [];
                    menu_id_list.map((menu_id) => {
                        const bool = (menu_id === check_menu_id);

                        if (bool) {
                            new_select_menu_id_list = [...new_select_menu_id_list, menu_id];
                        } else {
                            new_select_menu_id_list = new_select_menu_id_list.filter(function (item) {
                                return item != menu_id;
                            });
                        }
                    }
                    );
                    dispatch(MenuSet(["select_menu_id_list", new_select_menu_id_list]));
                }
            }
        }
    }, [menu_list]);

    const SelectCheck = (menu_id, bool) => {
        let new_select_menu_id_list = [];

        if (bool) {
            new_select_menu_id_list = [...select_menu_id_list, menu_id];
        } else {
            new_select_menu_id_list = select_menu_id_list.filter(function (item) {
                return item != menu_id;
            });
        }
        dispatch(MenuSet(["select_menu_id_list", new_select_menu_id_list]));
        // props.SelectCheck && props.SelectCheck(menu_id, bool);
    };

    const [select_detail_menu, set_select_detail_menu] = useState(false);

    const [select_menu, set_select_menu] = useState(false);

    const [show_all, set_show_all] = useState(true);

    const LinkClick = (menu_data) => {
        const url = "/ApplicationForm";

        const params = {
            party_date: party_date,
            menu_group_id: menu_group_id,
            menu_id: menu_data.menu_id,
        };

        const encodedurl = url + "?" + new URLSearchParams(params);

        history.push(encodedurl);
    };

    // 参加登録画面のプラン選択ボタン押下
    const SelectClick = (menu_data) => {
        set_select_menu(menu_data);
        set_show_all(false);
        onSelect && onSelect(menu_data);
    };
    // 参加登録画面のプラン再選択ボタン押下
    const ReselectClick = () => {
        set_show_all(true);
        onReselect && onReselect();
    };

    // プラン詳細の表示
    const OpenMenuDetail = (menu) => {
        set_select_detail_menu(menu);
    };
    // プラン詳細の非表示
    const CloseMenuDetail = (menu) => {
        set_select_detail_menu(false);
    };

    //公開から2週間以内ならNEW!表示
    const checkReleaseDate = (release_start_date) => {
        if(!release_start_date) return false;
        let check_date = new Date(release_start_date);
        check_date.setDate(check_date.getDate() + 14);
        if(check_date >= new Date())
        {
            return true;
        }
        return false;
    };

    return (
        <React.Fragment>
            <Grid
                container
                direction="row"
                justifyContent="flex-end"
                sx={{
                    display: show_all ? "none" : "flex",
                    m: 2,
                    mb: 0,
                }}
            >
                <Grid item>
                    <Button size="small" variant="outlined" onClick={ReselectClick}>
                        再選択する
                    </Button>
                </Grid>
            </Grid>
            <MenuDialog select_menu={select_detail_menu} handleClose={CloseMenuDetail} />

            {menu_list?.length >= 1 ? (
                <React.Fragment>
                    {menu_list.map((menu_data, index) => (
                        <React.Fragment key={index}>
                            <Box sx={{ p: 1, display: "flex" }}>
                                <Card
                                    sx={{
                                        maxWidth: 500,
                                        mt: "1rem",
                                        b: 1,
                                        boxShadow: 1,
                                        borderRadius: 5,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: show_all
                                                ? "flex"
                                                : select_menu == menu_data
                                                ? "flex"
                                                : select_menu == false
                                                ? "flex"
                                                : "none",

                                            flexDirection: "column",
                                            // filter:
                                            //     no_select_menu_id_list == menu_data
                                            //         ? ""
                                            //         : select_menu == false
                                            //         ? ""
                                            //         : "grayscale(100%)",

                                            filter: select_menu_id_list?.includes(menu_data?.menu_id)
                                                ? ""
                                                : "grayscale(100%)",
                                            // bgcolor: select_menu == menu_data ? "#fff" : select_menu == false ? "#fff" : "#7b7b7b",
                                            height: "100%",
                                            position: "relative"
                                        }}
                                    >
                                        {props?.SelectCheck ? (
                                            <Grid
                                                sx={{
                                                    position: "absolute",
                                                    "& .MuiSvgIcon-root": {
                                                        fontSize: "30px",
                                                        background: "#fff",
                                                        borderRadius: "0.3rem",
                                                    },
                                                }}
                                            >
                                                <Checkbox
                                                    name="memberListCheck"
                                                    checked={
                                                        select_menu_id_list?.includes(menu_data?.menu_id) ? true : false
                                                    }
                                                    onChange={(e) => SelectCheck(menu_data?.menu_id, e.target.checked)}
                                                />
                                            </Grid>
                                        ) : (
                                            ""
                                        )}
                                        <CardMedia
                                            component="img"
                                            image={menu_data.main_image_path}
                                            sx={{ width: "500px", maxWidth: "100%" }}
                                        />
                                        {checkReleaseDate(menu_data.release_start_date) && 
                                            <Typography 
                                                variant="h6" 
                                                component="div" 
                                                color="red" 
                                                sx={{position: "absolute", right: "10px", top: "10px", backgroundColor: "white", border: "2px solid red", boxShadow: "0 0 0 2px white", px: "5px", fontWeight: "bold"}}
                                            >
                                                New!
                                            </Typography>
                                        }
                                        <CardContent
                                            sx={{
                                                minHeight: "12rem",
                                            }}
                                        >
                                            
                                            <Typography variant="h6" component="div">
                                                {menu_data.menu_name}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: "3",
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    // minHeight: "5rem",
                                                }}
                                            >
                                                {menu_data.dishes}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                sx={{
                                                    mt: 1
                                                }}
                                            >
                                                プレゼントドリンク本数：{menu_data.present_drink_number}
                                            </Typography>
                                            <Button size="small" onClick={() => OpenMenuDetail(menu_data)}>
                                                詳細はこちら
                                            </Button>
                                        </CardContent>
                                        {app_button && (
                                            <ButtonBase
                                                size="small"
                                                variant="outlined"
                                                onClick={() => LinkClick(menu_data)}
                                                sx={{
                                                    bgcolor: "primary.main",
                                                    width: "100%",
                                                    height: "50px",
                                                    marginTop: "auto",
                                                }}
                                            >
                                                <Box> このプランで予約する</Box>
                                            </ButtonBase>
                                        )}
                                        {select_button && (
                                            <ButtonBase
                                                size="small"
                                                variant="outlined"
                                                onClick={() => SelectClick(menu_data)}
                                                sx={{
                                                    bgcolor: "primary.main",
                                                    width: "100%",
                                                    height: "50px",
                                                    marginTop: "auto",
                                                }}
                                            >
                                                <Box> 選択</Box>
                                            </ButtonBase>
                                        )}
                                        {onAdd && (
                                            <ButtonBase
                                                size="small"
                                                variant="outlined"
                                                onClick={() => onAdd(menu_data)}
                                                sx={{
                                                    bgcolor: "primary.main",
                                                    width: "100%",
                                                    height: "50px",
                                                    marginTop: "auto",
                                                }}
                                            >
                                                <Box> このメニューを追加</Box>
                                            </ButtonBase>
                                        )}
                                        {DelClick && (
                                            <ButtonBase
                                                size="small"
                                                variant="outlined"
                                                onClick={() => DelClick(menu_data, index)}
                                                sx={{
                                                    bgcolor: "red",
                                                    width: "100%",
                                                    height: "50px",
                                                    marginTop: "auto",
                                                }}
                                            >
                                                <Box> このメニューを削除</Box>
                                            </ButtonBase>
                                        )}
                                    </Box>
                                </Card>
                            </Box>
                        </React.Fragment>
                    ))}
                </React.Fragment>
            ) : (
                <Stack
                    direction="column"
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    sx={{
                        height: "500px",
                        pt: "5rem",
                    }}
                >
                    <Typography variant="body" color="text.secondary">
                        現在選択のコースはお料理を選択できません
                    </Typography>
                </Stack>
            )}
            {select_button && (
                <TextField
                    value={select_menu?.menu_id ? select_menu?.menu_id : ""}
                    name="select_menu"
                    sx={{ display: "none" }}
                ></TextField>
            )}
        </React.Fragment>
    );
};

export default MenuList;
